var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserFavorite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#user--favorite_svg__clip0_61530_7472)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.477 9a1.996 1.996 0 00-1.43.604l-.296.304-.297-.304a1.996 1.996 0 00-2.862 0 2.1 2.1 0 000 2.923l3.16 3.223 3.156-3.223a2.1 2.1 0 000-2.923A1.996 1.996 0 0020.478 9zM1.5 22.5H3v-3.75A3.755 3.755 0 016.75 15h4.5A3.755 3.755 0 0115 18.75v3.75h1.5v-3.75a5.256 5.256 0 00-5.25-5.25h-4.5a5.256 5.256 0 00-5.25 5.25v3.75zM9 3a3.75 3.75 0 110 7.5A3.75 3.75 0 019 3zm0-1.5A5.25 5.25 0 109 12 5.25 5.25 0 009 1.5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "user--favorite_svg__clip0_61530_7472"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgUserFavorite;